(function () {
	function IndexScroll() {
		var scroll_top = $(document).scrollTop();
		var s5 = scroll_top / 8;

		$('.pagetext-full').css('transform', 'translateX(-' + s5 + 'px)');
		$('.pagetext-line').css('transform', 'translateX(' + s5 + 'px)');
	}

	$(window)
		.on('load', function () {
			AllSliderCont();
		})
		.on('scroll', function () {
		})
		.on('resize', function () {
			AllSliderCont();
		});
		function AllSliderCont(){
			var NewsSlider = new Swiper('.swiper-container.newscard', {
				// autoplay:{delay:8,autoplayDisableOninteraction:false},
				loop: !1,
				autoplayDisableOninteraction:false,
				spaceBetween: 0,
				slidesPerView: 1,
				autoHeight: !0,
				watchSlidesVisibility: true,//防止不可点击
				watchSlidesProgress: true,
				navigation:{nextEl:".newscard .swiper-arrow.next",prevEl:".newscard .swiper-arrow.prev"},
				loopAdditionalSlides:1,
				pagination:{el:".newscard .swiper-pagination",clickable:!0},
				slideToClickedSlide: !0,
			});
		}
})();
